import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmainfo',
  templateUrl: './confirmainfo.component.html',
  styleUrls: ['./confirmainfo.component.css']
})
export class ConfirmainfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
